import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UISelect from 'UIComponents/input/UISelect';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { useAssetSortOptions } from '../../../hooks/useAssetSortOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export function AssetSortToggleGroup({
  onSelect,
  value,
  isUnifiedSearch
}) {
  const assetSortOptions = useAssetSortOptions(isUnifiedSearch);
  return /*#__PURE__*/_jsx(UIToggleGroup, {
    name: "sort",
    children: assetSortOptions.map(option => /*#__PURE__*/_jsx(UIRadioInput, {
      checked: option.value === value,
      onChange: () => onSelect(option.value),
      children: option.text
    }, option.value))
  });
}
export function AssetSortDropdown({
  className,
  disabled,
  isUnifiedSearch,
  onSelect,
  value
}) {
  const assetSortOptions = useAssetSortOptions(isUnifiedSearch);
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    className: classNames(className, 'm-right-0'),
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.sort.label"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      buttonUse: "transparent",
      disabled: disabled,
      menuWidth: 250,
      onChange: event => onSelect(event.target.value),
      options: assetSortOptions,
      searchable: false,
      value: value
    })
  });
}